import Seo from '../components/Seo';
import '../styles/insights.css';

const EFFECTIVE_DATE = '2026년 8월 14일';

export default function Privacy() {
  return (
    <article className="insight-article container container--narrow section">
      <Seo
        title="개인정보 처리방침"
        description="이지랩이 수집하는 개인정보 항목과 이용 목적, 보유 기간, 이용자의 권리를 안내합니다. 광고 쿠키 사용과 맞춤 광고 해제 방법도 함께 안내합니다."
        path="/privacy"
      />

      <header className="insight-head">
        <span className="insight-eyebrow">Legal</span>
        <h1>개인정보 처리방침</h1>
        <p className="insight-lead">
          주식회사 이지랩(이하 &lsquo;회사&rsquo;)은 이용자의 개인정보를
          중요하게 생각하며, 관련 법령을 준수합니다. 본 방침은 회사가 운영하는
          웹사이트(ezylab.co.kr)에 적용됩니다.
        </p>
      </header>

      <h2>1. 수집하는 개인정보 항목</h2>
      <p>
        회사는 회원가입 절차를 운영하지 않으며, 서비스 이용을 위해 이용자에게
        개인정보를 요구하지 않습니다. 다음의 경우에 한해 최소한의 정보를
        수집합니다.
      </p>

      <div className="insight-table">
        <table>
          <thead>
            <tr>
              <th>구분</th>
              <th>수집 항목</th>
              <th>수집 방법</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>프로젝트 문의</td>
              <td>이름, 이메일 주소, 회사명, 문의 내용</td>
              <td>문의 폼 입력 (이용자가 직접 제출)</td>
            </tr>
            <tr>
              <td>광고 게재</td>
              <td>쿠키를 통한 브라우저 정보, 방문 기록</td>
              <td>Google AdSense 자동 수집</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        문의 폼은 이용자가 직접 입력하고 제출할 때에만 정보가 전달되며, 입력
        도중의 내용은 어디에도 저장되지 않습니다.
      </p>

      <h2>2. 개인정보의 이용 목적</h2>
      <ul>
        <li>
          <strong>문의 응대</strong> — 프로젝트 상담 회신 및 관련 안내
        </li>
        <li>
          <strong>광고 게재</strong> — 웹사이트 운영을 위한 광고 노출
        </li>
      </ul>
      <p>
        회사는 수집한 정보를 위 목적 외의 용도로 사용하지 않으며, 마케팅 수신
        동의를 받거나 광고성 정보를 발송하지 않습니다.
      </p>

      <h2>3. 보유 및 이용 기간</h2>
      <p>
        문의 내용은 상담이 완료된 후 <strong>1년</strong>간 보관하며, 이후
        지체 없이 파기합니다. 이용자가 삭제를 요청하는 경우 즉시 파기합니다.
        관련 법령에서 일정 기간 보존을 요구하는 경우에는 해당 기간 동안
        보관합니다.
      </p>

      <h2>4. 제3자 제공 및 처리 위탁</h2>
      <p>
        회사는 이용자의 개인정보를 제3자에게 판매하거나 제공하지 않습니다. 다만
        서비스 제공에 필요한 범위에서 다음 업체에 처리를 위탁하고 있습니다.
      </p>

      <div className="insight-table">
        <table>
          <thead>
            <tr>
              <th>수탁 업체</th>
              <th>위탁 업무</th>
              <th>제공 정보</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>EmailJS</td>
              <td>문의 내용 이메일 전달</td>
              <td>이름, 이메일, 회사명, 문의 내용</td>
            </tr>
            <tr>
              <td>Google LLC</td>
              <td>광고 게재 (AdSense)</td>
              <td>쿠키를 통한 브라우저 정보, 방문 기록</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>5. 쿠키와 광고</h2>
      <p>
        회사는 이용자를 식별하기 위한 자체 쿠키를 사용하지 않습니다. 다만 본
        웹사이트에는 Google AdSense 광고가 게재되며,{' '}
        <strong>
          Google을 포함한 제3자 공급업체는 쿠키를 사용하여 이용자가 본 웹사이트
          또는 다른 웹사이트를 방문한 기록을 바탕으로 광고를 게재합니다.
        </strong>
      </p>

      <div className="insight-callout">
        <strong>맞춤 광고를 원하지 않으신다면</strong>
        <p>
          <a
            href="https://www.google.com/settings/ads"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google 광고 설정
          </a>
          에서 맞춤 광고를 해제할 수 있습니다. 여러 업체의 맞춤 광고를 한 번에
          해제하시려면{' '}
          <a
            href="https://www.aboutads.info/choices/"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.aboutads.info
          </a>
          를 이용해 주세요. 브라우저 설정에서 쿠키 저장을 거부하실 수도 있으며,
          이 경우 광고가 관심사와 무관하게 표시될 수 있습니다.
        </p>
      </div>

      <p>
        Google의 데이터 처리에 대한 자세한 내용은{' '}
        <a
          href="https://policies.google.com/technologies/partner-sites"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google 파트너 사이트 데이터 사용 방침
        </a>
        에서 확인하실 수 있습니다.
      </p>

      <h2>6. 이용자의 권리</h2>
      <p>
        이용자는 언제든지 자신의 개인정보에 대해 열람, 정정, 삭제, 처리 정지를
        요청할 수 있습니다. 아래 연락처로 요청해 주시면 지체 없이 조치하고
        결과를 알려 드립니다.
      </p>

      <h2>7. 개인정보의 파기</h2>
      <p>
        보유 기간이 지나거나 처리 목적이 달성된 개인정보는 지체 없이
        파기합니다. 전자적 파일은 복구할 수 없는 방법으로 삭제하며, 출력물이
        있는 경우 분쇄하거나 소각합니다.
      </p>

      <h2>8. 안전성 확보 조치</h2>
      <ul>
        <li>
          <strong>전송 구간 암호화</strong> — 웹사이트 전 구간에 HTTPS를
          적용합니다.
        </li>
        <li>
          <strong>접근 권한 최소화</strong> — 문의 내용은 상담 담당자만 확인할
          수 있습니다.
        </li>
        <li>
          <strong>수집 최소화</strong> — 회원가입을 운영하지 않으며 문의에
          필요한 항목만 받습니다.
        </li>
      </ul>

      <h2>9. 만 14세 미만 아동</h2>
      <p>
        본 웹사이트는 기업 대상 서비스 소개를 목적으로 하며, 만 14세 미만
        아동을 대상으로 하지 않습니다. 회사는 만 14세 미만 아동의 개인정보를
        의도적으로 수집하지 않습니다.
      </p>

      <h2>10. 개인정보 보호책임자 및 문의처</h2>
      <ul>
        <li>회사명: 주식회사 이지랩</li>
        <li>사업자등록번호: 401-86-02205</li>
        <li>주소: 서울특별시 영등포구 양평로 24, 5층</li>
        <li>
          이메일:{' '}
          <a href="mailto:goootae@ezylab.co.kr">goootae@ezylab.co.kr</a>
        </li>
      </ul>
      <p>
        개인정보 침해로 인한 상담이 필요하신 경우 개인정보침해신고센터
        (privacy.kisa.or.kr, 국번 없이 118) 등에 문의하실 수 있습니다.
      </p>

      <h2>11. 방침의 변경</h2>
      <p>
        본 방침이 변경되는 경우 시행일과 변경 내용을 웹사이트에 공지합니다.
        중요한 변경이 있을 때에는 시행 7일 전부터 안내합니다.
      </p>

      <p className="insight-note">
        ※ 시행일: {EFFECTIVE_DATE} · 본 방침은 ezylab.co.kr 웹사이트에
        적용됩니다. 포춘로또 등 회사가 운영하는 개별 서비스는 각 서비스의
        개인정보 처리방침을 따릅니다.
      </p>
    </article>
  );
}
